import { observer, useLocalObservable } from "mobx-react";
import React, { useCallback, useEffect } from "react";
import { M365PulseFlyout, M365PulseLink, M365PulseSearchBox, SearchResultItem } from "Shared/Components";

import { Button } from "@fluentui/react-components";
import { useBoolean } from "Shared/Hooks/Util";

import { AppLeftBarItem as IAppLeftBarItem } from "../AppLeftBarMenuItems";
import { useOverflowFlyoutStyles } from "./OverflowFlyout.styles";
import { OverflowMenuItem } from "./OverflowMenuItem";

const emptySearchResult = new Array<SearchResultItem>();

const OverflowFlyoutBase = ({ showFlyout, onDismissCallback, apps }: { apps: IAppLeftBarItem[]; showFlyout: boolean; onDismissCallback: () => void }) => {
    const classnames = useOverflowFlyoutStyles();

    const [isOpen, { setTrue: openPanel, setFalse: dismissPanel }] = useBoolean(false);

    useEffect(() => {
        showFlyout ? openPanel() : dismissPanel();
    }, [dismissPanel, openPanel, showFlyout]);

    const onDismiss = useCallback(() => {
        dismissPanel();
        onDismissCallback();
    }, [dismissPanel, onDismissCallback]);

    const localStore = useLocalObservable(() => ({
        menuOpen: false,
        searchText: "",
        filteredApps: apps
    }));

    const onSearchChange = useCallback(
        (keyword: string) => {
            const trimmed = keyword.trim().toLowerCase();
            localStore.searchText = trimmed;
            localStore.filteredApps = trimmed ? apps.filter((app) => app.displayName.toLowerCase().includes(trimmed)) : apps;
        },
        [apps, localStore]
    );

    return (
        <M365PulseFlyout title="More Apps" onRequestClose={onDismiss} isOpen={isOpen}>
            <div className={classnames.menu}>
                <M365PulseSearchBox className={classnames} searchResultList={emptySearchResult} onSearchChange={onSearchChange} placeholder="Find an app" />
                <div className={classnames.appList}>
                    {localStore.filteredApps.map((app, index) => (
                        <OverflowMenuItem key={index} app={app} onClick={onDismiss} />
                    ))}
                </div>
                <div className={classnames.footer}>
                    <M365PulseLink path="/apphub">
                        <Button className={classnames.button}>Get more apps</Button>
                    </M365PulseLink>
                </div>
            </div>
        </M365PulseFlyout>
    );
};

export const OverflowFlyout = observer(OverflowFlyoutBase);
